import { ref } from 'vue';
import { defineStore } from 'pinia';

import { formatWithCurrency, formatWithoutCurrencySymbol } from '@libs/utils';

export const useGlobalCurrencyStore = defineStore('GlobalCurrencyStore', () => {
  // State
  // Default currency, this value will be set after first call of formatMoney with currency
  const globalCurrency = ref<string>();

  // Helpers
  function formatMoney(amount: number, currency?: string): string {
    if (
      currency !== undefined &&
      currency !== '' &&
      globalCurrency.value === undefined
    ) {
      globalCurrency.value = currency;
    }
    return formatWithCurrency(amount, currency);
  }

  function formatWithoutCurrency(amount: number): string {
    return formatWithoutCurrencySymbol(amount);
  }

  return {
    // State
    globalCurrency,
    // Helpers
    formatMoney,
    formatWithoutCurrency,
  };
});
